import React, {useEffect, useState} from 'react';
import {useAppDispatch} from "../app/hooks";
import {Image, Progress} from "antd";
import {setClapFile, setMode} from "../features/omikuji/omikujiSlice";
import {AudioOutlined} from "@ant-design/icons";

URL = window.URL || window.webkitURL;

var gumStream: any; 						//stream from getUserMedia()
var rec: any; 							//Recorder.js object
var input; 							//MediaStreamAudioSourceNode we'll be recording

// shim for AudioContext when it's not avb.
var AudioContext = window.AudioContext // || window.webkitAudioContext;
var audioContext //audio context to help us record

export function Screen7_Clap_record3sec(props: any) {

    const dispatch = useAppDispatch();
    let currentPercent = 100
    let isMoving = false
    const [percent, setPercent] = useState(currentPercent)
    const getPercentText = (percent: number) => {
        if (percent === 100) {
            return 3
        }
        if (percent >= (100 - 32)) {
            return 2
        }
        if (percent >= (100 - 32 - 32)) {
            return 1
        }
        return 0
    }

    function startRecording() {
        // console.log("recordButton clicked");

        /*
            Simple constraints object, for more advanced audio features see
            https://addpipe.com/blog/audio-constraints-getusermedia/
        */

        var constraints = {audio: true, video: false}

        /*
           Disable the record button until we get a success or fail from getUserMedia()
       */
        //
        // recordButton.disabled = true;
        // stopButton.disabled = false;
        // pauseButton.disabled = false

        /*
            We're using the standard promise based getUserMedia()
            https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
        */

        navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
            // console.log("getUserMedia() success, stream created, initializing Recorder.js ...");

            /*
                create an audio context after getUserMedia is called
                sampleRate might change after getUserMedia is called, like it does on macOS when recording through AirPods
                the sampleRate defaults to the one set in your OS for your playback device
            */
            audioContext = new AudioContext();

            //update the format
            // document.getElementById("formats").innerHTML="Format: 1 channel pcm @ "+audioContext.sampleRate/1000+"kHz"

            /*  assign to gumStream for later use  */
            gumStream = stream;

            /* use the stream */
            input = audioContext.createMediaStreamSource(stream);

            /*
                Create the Recorder object and configure to record mono sound (1 channel)
                Recording 2 channels  will double the file size
            */
            // @ts-ignore
            rec = new Recorder(input, {numChannels: 1})

            //start the recording process
            // console.log(1)
            rec.record()

            // console.log("Recording started");

            setInterval(() => {
                const current = currentPercent
                const next = current - 32
                currentPercent = next
                setPercent(currentPercent)
            }, 1000)

        }).catch(function (err) {
            //enable the record button if getUserMedia() fails
        });
    }

    useEffect(() => {
        if (isMoving) return
        isMoving = true
        startRecording();
    }, [])
    const blobToBase64 = (blob: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
        });
    };
    useEffect(() => {
        if (percent < (100 - 32 - 32)) {
            rec.stop();

            //stop microphone access
            gumStream.getAudioTracks()[0].stop();

            //create the wav blob and pass it on to createDownloadLink
            rec.exportWAV((blob: any) => {
                blobToBase64(blob).then((res) => {
                    // do what you wanna do
                    // console.log(res); // res is base64 now
                    dispatch(setClapFile(res as string))
                });
            });

            dispatch(setMode("mode8_Loading"))
        }
    }, [percent])
    return <>
        <p>２回手を叩こう👏👏</p>
        <p style={{color: "#900", fontWeight: "bold"}}>
            <AudioOutlined/>
            録音中
        </p>
        <Progress type="circle" percent={percent} format={(percent) => {
            return percent ? getPercentText(percent) : 0
        }
        }/>
        <p>
            <Image
                src="/images/hands.png"
                preview={false}
                alt="AIおみくじ2023"
            />
        </p>
    </>
}
